import { request as https, requestPost } from "./request";
import { baseUrl } from './userRequest';

export const  newBaseUrl = "https://vasudeep.com:8084/http://optiswift.com/public/asas/public/api";
// export const  newBaseUrl = "http://127.0.0.1:8000/api";

export const loginRequest = (params) => {  
  return requestPost.post(`${newBaseUrl}/login`, params);
};

export const userProfileRequest = (params) => {  
  return https.get(`${newBaseUrl}/user/profile`, params);
};

export const userUpdateProfileRequest = (params) => {  
  return requestPost.post(`${newBaseUrl}/user/update/profile`, params);
};

export const profileUpdateRequest = (params={}) => {
  return requestPost.post(`${newBaseUrl}/user/update/profile`, params);
};

export const googleLoginRequest = (params={}) => {
  return requestPost.post(`${newBaseUrl}/google/login`, params);
};

export const adminUsersListRequest = (params={}) => {
  return https.get(`${newBaseUrl}/admin/users`, params);
};

export const googleApiRequest = (params={}) => {
  return requestPost.post(`${newBaseUrl}/google/login`, params);
};